import { render, staticRenderFns } from "./QuestionResult.vue?vue&type=template&id=77007194&scoped=true&"
import script from "./QuestionResult.vue?vue&type=script&lang=js&"
export * from "./QuestionResult.vue?vue&type=script&lang=js&"
import style0 from "./QuestionResult.vue?vue&type=style&index=0&id=77007194&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77007194",
  null
  
)

export default component.exports